import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-developer-error-category',
    templateUrl: './developer-error-category.component.html',
    styleUrls: ['./developer-error-category.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule]
})
export class DeveloperErrorCategoryComponent implements OnInit {
    public formData: UntypedFormGroup;

    constructor(
        public modal: NgbActiveModal,
        private fb: UntypedFormBuilder) { }

    ngOnInit(): void {
        this.formData = this.buildForm();
    }

    buildForm(): UntypedFormGroup {
        return this.fb.group({
            name: ['', Validators.required],
            description: ['', Validators.required]
        });
    }

    ok(): void {
        if (this.formData.valid) {
            this.modal.close(this.formData.value);
        }
    }

    cancel(): void {
        this.modal.dismiss();
    }
}
